import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI } from '../../../utils/CmsAPI';
import config from '../../../config';
import { currentDate } from '../../../utils/Helper';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response) => {
  const responseData = response.data;
  const data = responseData.result.assets[0];
  if (!data) {
    throw new Error('no data');
  }
  return data;
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = (pageName, pageType) => {
  const url = CMSAPI(
    config.lscsPath,
    pageName,
    pageType,
    config.cmsProjectName,
    true,
    currentDate().getTime(),
  );
  return axiosAdapter({
    url,
  });
};

const resetPages = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const getPages = (pageName, pageType = 'Pages/Static Page') => {
  return (dispatch) => {
    dispatch(requestFetch({ pageName, pageType }));
    return fetchData(pageName, pageType)
      .then((response) => massageData(response))
      .then((data) => {
        dispatch(receiveSuccess(data));
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getPages, resetPages };
